class FacetFilters extends HTMLElement {
    constructor() {
        super();
        this.form = this.querySelector('form');
        this.drawer = document.querySelector('[data-facets-wrapper]');
        this.openBtns = document.querySelectorAll('[data-filter-open]');
        this.closeBtns = document.querySelectorAll('[data-facets-close]');
        this.applyBtn = document.querySelector('[data-facets-apply]');

        this.bindEvents();
    }

    bindEvents() {
        if (this.openBtns.length > 0 && this.drawer) {
            this.openBtns.forEach(btn => {
                btn.addEventListener('click', () => {
                    this.drawer.classList.add('is-open');
                    document.body.style.overflow = 'hidden';
                });
            });
        }

        if (this.closeBtns && this.drawer) {
            this.closeBtns.forEach(btn => {
                btn.addEventListener('click', () => {
                    this.drawer.classList.remove('is-open');
                    document.body.style.overflow = '';
                });
            });
        }

        if (this.applyBtn && this.form) {
            this.applyBtn.addEventListener('click', (e) => {
                e.preventDefault();
                this.onSubmit();
            });
        }
    }

    onSubmit() {
        const formData = new FormData(this.form);
        const searchParams = new URLSearchParams(formData);

        // Remove empty parameters
        for (const [key, value] of Array.from(searchParams.entries())) {
            if (!value) searchParams.delete(key);
        }

        const url = `${window.location.pathname}?${searchParams.toString()}`;
        window.location.href = url;
    }
}

if (!customElements.get('facet-filters-form')) {
    customElements.define('facet-filters-form', FacetFilters);
}
